import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Progress } from "@/components/ui/progress";
import { Copy, Cpu, X } from "lucide-react";

export function BatchPanel({ selectedCount, includeGeo, setIncludeGeo, onCopy, onExportSelection, onExportEdited, editedCount, batch }) {
  return (
    <div className="space-y-3" data-testid="batch-panel">
      <h4 className="text-[10px] uppercase tracking-[0.2em] text-[#64748B] font-semibold">Traitement par lots</h4>
      <p className="text-[11px] text-[#94A3B8]" data-testid="batch-selection-count">{selectedCount ? `${selectedCount} photo(s) selectionnee(s) dans la bande` : "Cochez des photos dans la bande pour les traiter ensemble."}</p>
      <label className="flex items-center gap-2 text-[11px] text-[#94A3B8] cursor-pointer">
        <Checkbox checked={includeGeo} onCheckedChange={(v) => setIncludeGeo(!!v)} data-testid="batch-include-geometry" />Inclure recadrage et rotation
      </label>
      <Button size="sm" onClick={onCopy} disabled={!selectedCount || batch.running} className="w-full h-8 text-xs bg-[#0099CC] hover:bg-[#0088B5] text-white" data-testid="batch-copy-btn">
        <Copy className="w-3.5 h-3.5 mr-1.5" />Copier les reglages vers la selection
      </Button>
      <Button size="sm" onClick={onExportSelection} disabled={!selectedCount || batch.running} className="w-full h-8 text-xs bg-[#F97316] hover:bg-[#EA580C] text-white" data-testid="batch-export-selection-btn">
        <Cpu className="w-3.5 h-3.5 mr-1.5" />Generer les JPEG HD de la selection
      </Button>
      <Button size="sm" variant="outline" onClick={onExportEdited} disabled={!editedCount || batch.running} className="w-full h-8 text-xs bg-transparent border-[#1A2332] text-[#94A3B8]" data-testid="batch-export-edited-btn">
        Generer toutes les photos a mettre a jour ({editedCount})
      </Button>
      {(batch.running || batch.total > 0) && (
        <div className="rounded-lg border border-[#1A2332] bg-[#060B14] p-3 space-y-2" data-testid="batch-progress">
          <div className="flex items-center justify-between text-[11px]">
            <span className="text-white font-mono" data-testid="batch-progress-count">{batch.done}/{batch.total}</span>
            {batch.running
              ? <button onClick={batch.cancel} className="text-[#94A3B8] hover:text-white" data-testid="batch-cancel">Arreter</button>
              : <button onClick={batch.reset} className="text-[#64748B] hover:text-white"><X className="w-3.5 h-3.5" /></button>}
          </div>
          <Progress value={batch.total ? (batch.done / batch.total) * 100 : 0} className="h-1.5 bg-[#1A2332]" />
          {batch.current && <p className="text-[10px] text-[#64748B] truncate">Rendu HD : {batch.current}</p>}
          {batch.errors.length > 0 && <p className="text-[10px] text-amber-400">{batch.errors.length} echec(s) : {batch.errors.map((e) => e.name).join(", ")}</p>}
        </div>
      )}
    </div>
  );
}
